import { createSlice } from "@reduxjs/toolkit";
import { getFields } from "./thunk";

export interface IState {
  Fields: any;
  isFieldLoading: boolean;
  isFieldSuccess: boolean;

  error: any;
}

export const initialState: IState = {
  Fields: null,
  isFieldLoading: false,
  isFieldSuccess: false,

  error: {},
};

const FieldsSlice = createSlice({
  name: "Fields",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    //get Fields
    builder.addCase(getFields.pending, (state: IState, action: any) => {
      state.isFieldLoading = true;
    });
    builder.addCase(getFields.fulfilled, (state: IState, action: any) => {
      state.Fields = action.payload?.data;
      state.isFieldSuccess = true;
      state.isFieldLoading = false;
    });
    builder.addCase(getFields.rejected, (state: IState, action: any) => {
      state.error = action.payload.error || null;
      state.isFieldSuccess = false;
      state.isFieldLoading = false;
    });

  },
});

export default FieldsSlice.reducer;